import * as React from 'react';

const RightArrowHead = () => (
  <svg width="0.7em" height="0.7em" viewBox="0 0 8 12" fill="none">
    <path
      d="M1.5 1l4.9 4.764A.332.332 0 016.5 6a.325.325 0 01-.1.236L1.5 11"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(RightArrowHead);
